import { render, staticRenderFns } from "./QuestionPaperPackageDetail.vue?vue&type=template&id=37c79b58&scoped=true&"
import script from "./QuestionPaperPackageDetail.vue?vue&type=script&lang=js&"
export * from "./QuestionPaperPackageDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPaperPackageDetail.vue?vue&type=style&index=0&id=37c79b58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c79b58",
  null
  
)

export default component.exports